// extracted by mini-css-extract-plugin
export default {"info":"Feedback_info__cG8LH","error":"Feedback_error__Fs1pQ"};